export const environment = {
  production: false,
  skipAuth: true,
  // apiUrl: 'http://localhost:8000/api',
  // baseUrl: 'http://localhost:8000/api',
  apiUrl: 'https://dev-linkweaver.pamconsultants.com/api',
  baseUrl: 'https://dev-linkweaver.pamconsultants.com/api',
  workos: {
   clientId: 'client_01KA11VRTPJBTSR9WW0KA40WRQ',
    apiKey: '',
    redirectUri: 'https://dev-linkweaver.pamconsultants.com/auth/callback'
  },
  dev: {
    mode: 'normal', // 'normal' or 'noprocess' - skips file upload/processing steps
    project_name: 'project2025-12-13-130238' // Existing project name to use when mode is 'noprocess'
  },
  productUrls: {
    linkWeaver: 'https://dev-linkweaver.pamconsultants.com/dashboard',
    polyScribe: 'https://dev-polyscribe.pamconsultants.com',
  }
};
